settings_module = settings_module or {}
settings_module.rate_detail = (lang)->

    Gettext._locale_data = {}
    gt.try_load_lang_po('/static/frontend_bat/app-backbone/locale/' + LOCALE_LOOKUP.gettext[lang] + '/messages.po')

    max_width = $("#content").width()

    # TODO:
    # - ve formiku musim zajistit ze se mi do switching hidden prvku dostane JSON s udaji o spinani
    # - upravit switching_handler tak, aby pri fadeIn vytahl udaje z formiku a vytvoril z nich novou instanci iniciovanou prave temito udaji;
    #   ale bacha, jen v pripadech ze jeste neexistuje
    # - fadeOut musi naopak aktualni stav ve JS widgetu uchovat ve formik poli

    $price0 = $('#id_price0')
    $price1 = $('#id_price1')
    $price2 = $('#id_price2')
    $rateswitching = $('#rateswitching')
    switching_widget = null

    # Vrati seznam tarifu v podobe [{label:, id:}]. Jejich set vyhodnocuje podle policek priceX
    # ve formulari.
    get_rates = ()->
        levels = [
            val:0
            label:$price0.text()
            id:0
        ,
            val:0
            label:$price1.text()
            id:1
        ,
            val:0
            label:$price2.text()
            id:2
        ]
        x = _.reject(levels, (i)-> (_.isUndefined(i.val) || (i.val.length < 1) || _.isNaN(parseInt(i.val))))
        rates = _.map(x, (i)-> _.omit(i, 'val'))

        return rates

    # TODO:
    remove_widget = ()->
        if not _.isNull(switching_widget)
            json = switching_widget.get_switching_data() # TODO: nevim jestli to funguje jak ma; zkontrolovat
            switching_widget.close()
            switching_widget = null

    # Obsluha policek se zadavanim ceny pro 1/2 level
    switching_handler = ()->

        rates = get_rates()

        rates_id_lut = _.map(rates, (i)-> i.id)
        if rates.length > 0
            if not _.isNull(switching_widget)
                remove_widget()

            config =
                place: '#switching_place'
                rates: rates
                readonly: true
                days: SWITCHING_DATA
                chart_params:
                    width: if max_width < 600 then max_width else undefined
            switching_widget = new SwitchingController(config)
            $rateswitching.fadeIn()
        else
            $rateswitching.fadeOut()
            remove_widget()

    switching_handler()
